// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s1-0";
export var leftAlign = "_s1-4";
export var listItem = "_s1-2";
export var listItemWrapper = "_s1-1";
export var operationText = "_s1-3";